var useCardVariantBackground = function useCardVariantBackground(_ref) {
  var variant = _ref.variant;

  switch (variant) {
    case 'darker':
      return 'navyblue-600';

    case 'dark':
      return 'navyblue-500';

    case 'lighter':
      return 'navyblue-300';

    case 'light':
    default:
      return 'navyblue-400';
  }
};

export default useCardVariantBackground;